import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, LinearProgress as MuiLinearProgress, Typography, } from '@mui/material';
const LinearProgress = (props) => {
    const { label, ...muiProps } = props;
    return (_jsxs(Box, { sx: { alignItems: 'center', display: 'flex', mx: 2 }, children: [_jsx(Box, { sx: { mr: 1, width: '100%' }, children: _jsx(MuiLinearProgress, { variant: "determinate", ...muiProps }) }), _jsx(Box, { sx: { minWidth: 35 }, children: _jsx(Typography, { variant: "body2", color: "text.primary", children: label }) })] }));
};
export default LinearProgress;
